import React from 'react'
import { MuiStack } from './MuiStack'
import { CircularProgress } from '@mui/material'

export const CircularLoader = (props: any) => {
    const { sx, size } = props
    return (
        <MuiStack sx={sx}>
            <CircularProgress size={size || 40} />
        </MuiStack>
    )
}
